class TitleBarBehaviour {
  static id = 'title-bar';

  constructor(node) {
    if (!('IntersectionObserver' in window) || !node.dataset.subject) {
      return;
    }

    this.node = node;
    this.subjectNode = document.querySelector(node.dataset.subject);
    this.secondarySubjectNode = node.dataset.secondarySubject
      ? document.querySelector(node.dataset.secondarySubject)
      : null;
    const threshold = node.dataset.threshold || 0.5;
    const secondaryThreshold = 0.25;

    this.node.addEventListener('transitionend', this.handleVisibility);

    const observer = new IntersectionObserver(
      (changes) => {
        // XXX: isIntersecting seems to be incorrect in some browser so just check our threshold
        // directly against the intersectionRatio
        changes.forEach((change) => {
          if (change.target === this.subjectNode) {
            if (change.intersectionRatio < threshold) {
              this.node.classList.add('sticky');
            } else {
              this.node.classList.remove('sticky');
              this.closeExpandedElements();
            }
          }
          if (change.target === this.secondarySubjectNode) {
            if (!change.isIntersecting && change.boundingClientRect.top < 0) {
              this.node.classList.add('show-secondary');
            } else {
              this.node.classList.remove('show-secondary');
            }
          }
        });
      },
      { threshold: [0, threshold] }
    );

    observer.observe(this.subjectNode);
    if (this.secondarySubjectNode) {
      observer.observe(this.secondarySubjectNode);
    }
  }

  handleVisibility = () => {
    if (this.node.classList.contains('sticky')) {
      this.node.classList.remove('title-bar--hidden');
    } else {
      this.node.classList.add('title-bar--hidden');
    }
  };

  closeExpandedElements = () => {
    const expandedElements = this.node.querySelectorAll('[aria-expanded="true"]');
    expandedElements.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      const dropdown = button.nextElementSibling;
      if (dropdown) {
        dropdown.setAttribute('hidden', true);
      }
    });
  };
}

export default TitleBarBehaviour;
